export enum ProductLanguage {
    ENGLISH = "ENGLISH",
    RUSSIAN = "RUSSIAN",
    KOREAN = "KOREAN",
}

export enum ProductStatus {
    PAUSE = 'PAUSE',
    PROCESS = 'PROCESS',
    DELETE = 'DELETE',
}

export enum ProductCollection {
    FICTION = 'FICTION',
    NON_FICTION = 'NON_FICTION',
    ACADEMIC = "ACADEMIC",
    KIDS = 'KIDS',
    OTHER = 'OTHER'
}

export enum ProductFormat {
    PAPERBACK = 'PAPERBACK',
    HARDCOVER = 'HARDCOVER',
    E_BOOK = "E-BOOK",
    AUDIOBOOK = 'AUDIOBOOK',
}

export enum LikeGroup {
    PRODUCT = "PRODUCT",
}
